"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomGallery = void 0;
var React = require("react");
var react_1 = require("react");
var react_photo_gallery_1 = require("react-photo-gallery");
var SelectedImageRenderer_1 = require("./SelectedImageRenderer");
exports.CustomGallery = function (_a) {
    var photos = _a.photos, selectedEvent = _a.selectedEvent;
    var imageRenderer = react_1.useCallback(function (_a) {
        var index = _a.index, left = _a.left, top = _a.top, key = _a.key, photo = _a.photo;
        return (React.createElement(SelectedImageRenderer_1.default, { selected: false, key: key, margin: "2px", index: index, photo: photo, left: left, top: top, direction: null, onClick: function (e, _a) {
                var photo = _a.photo, index = _a.index, isSelected = _a.isSelected;
                return selectedEvent(photo, !isSelected);
            } }));
    }, []);
    return (React.createElement("div", null,
        React.createElement(react_photo_gallery_1.default, { photos: photos, renderImage: imageRenderer })));
};
//# sourceMappingURL=CustomGallery.js.map